import React from 'react';
import { CDS, PROFILE } from '../../constants/status';
import Tooltip from '../Tooltip';
/**
 * Icon component returns CDS and/or PROFILE Icon with hover text
 * @param qTag 
 * @param customstyle 
 * @param toolTipId 
 * @returns Tooltip
 */
const Icon = ({iPeds, qTag, customstyle, toolTipId = ''}) =>{
  const mystyle = customstyle?customstyle:{padding:'20px 10px 0px 0px'};
  const iconflg = qTag?.toUpperCase();
  const cds = iconflg?.includes(CDS);
  const profile =iconflg?.includes(PROFILE);

  const IconToolTip = ({toolTipMessage, iconType, toolId = toolTipId}) => {
    return (<span style={mystyle}>
              <Tooltip tooltipid={`tooltip_${toolId}`} tooltipMsg={toolTipMessage} className={iconType} />
            </span>);
  };
  return (
    <>
    {cds && <IconToolTip toolTipMessage={'CDS Question'} toolId={`cds${toolTipId}`} iconType={'cb-icon cb-compose cb-black-color'}/>}
    {iPeds && <IconToolTip toolTipMessage={'IPEDS Question'} toolId={`ipeds${toolTipId}`} iconType={'cb-icon cb-black-color'}/>}
    </>
  );

};

export default Icon;